import { createContext, useState, useEffect } from "react";

const TransactionContext = createContext();

const TransactionState = (props) => {
  let initialTransactions = [];

  const [transactions, setTransactions] = useState(initialTransactions);

  const [tId, settId] = useState("");

  const settingId = (id) => {
    settId(id);
  };

  const getTransactions = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/transaction/fetchTransactions`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );
    const result = await response.json();

    setTransactions(result);
  };

  const editTransaction = async (id, payload) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/transaction/editTransaction/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(payload ),
      },
    );

    const result = await response.json();

    if (!result.success) {
      console.error("Edit failed:", result);
      return;
    }

   


    await getTransactions();
  };

  const deleteTransaction = async (id) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/transaction/deleteTransaction/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "auth-token": localStorage.getItem("token"),
        },
      },
    );
    const json = response.json();

    const newTransactions = transactions.filter((t) => {
      return t._id !== id;
    });
    setTransactions(newTransactions);
  };

  const confirmPayment = async (senderId, receiverId, transId) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/transaction/confirmPayment?senderId=${senderId}&receiverId=${receiverId}&transId=${transId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );

    const json = response.json();
  };

  const approvePayment = async (senderId, receiverId, transId) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/transaction/approvePayment?senderId=${senderId}&receiverId=${receiverId}&transId=${transId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "auth-token": localStorage.getItem("token"),
        },
      },
    );

    const json = response.json();
  
  };

  const rejectPayment = async (senderId, receiverId, transId) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/transaction/rejectPayment?senderId=${senderId}&receiverId=${receiverId}&transId=${transId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );

    const json = response.json();
  };

  return (
    <TransactionContext.Provider
      value={{
        transactions,
        getTransactions,
        editTransaction,
        deleteTransaction,
        settingId,
        confirmPayment,
        approvePayment,
        rejectPayment,
        tId,
      }}
    >
      {props.children}
    </TransactionContext.Provider>
  );
};

export { TransactionState, TransactionContext };
